import { isOutOfStock } from '../../../../utils/shopItems'

/**
 * Check if an item is available (not out of stock)
 */
const isAvailable = (item) => item && !isOutOfStock(item)

/**
 * Get all selected items for cart based on configuration state
 * Filters out any out of stock items
 *
 * @param {Object} params
 * @param {Object|null} params.cockpitItem - Selected cockpit item
 * @param {Object|null} params.mountKitItem - Zero-cost front/bottom mount kit
 * @param {boolean} params.includeSeat - Whether seat is selected
 * @param {Object|null} params.seatItem - Seat item
 * @param {Array} params.monitorStandGroups - Monitor stand groups with variants
 * @param {Object} params.selectedAccessories - Map of accessoryId -> boolean
 * @param {Object} params.selectedVesaVariants - Map of groupId -> variantId
 * @param {Array} params.otherAccessories - Other accessory items
 * @returns {Array} Selected items for cart (excludes out of stock items)
 */
export function getSelectedItems({
  cockpitItem,
  mountKitItem,
  includeSeat,
  seatItem,
  monitorStandGroups,
  selectedAccessories,
  selectedVesaVariants,
  otherAccessories
}) {
  const items = []

  // Add cockpit if available
  if (isAvailable(cockpitItem)) {
    items.push(cockpitItem)
  }

  // The mount kit follows the chassis it belongs to: only ever added alongside
  // a cockpit, never on its own.
  if (isAvailable(cockpitItem) && isAvailable(mountKitItem)) {
    items.push(mountKitItem)
  }

  // Add seat if selected and available
  if (includeSeat && isAvailable(seatItem)) {
    items.push(seatItem)
  }

  // Add selected monitor stand groups (with correct VESA variant) if available
  monitorStandGroups.forEach(group => {
    if (selectedAccessories[group.id]) {
      const selectedVariantId = selectedVesaVariants[group.id]
      const variant = group.variants.find(v => v.id === selectedVariantId) || group.defaultVariant
      if (isAvailable(variant)) {
        items.push(variant)
      }
    }
  })

  // Add selected other accessories if available
  otherAccessories.forEach(acc => {
    if (selectedAccessories[acc.id] && isAvailable(acc)) {
      items.push(acc)
    }
  })

  return items
}
